import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EfSpec from '@elem/ui/ef-spec';
import { useRouter } from 'next/router';
import { useState } from 'react';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('Oasis.SubscriptionPlan');
    const [active, setActive] = useState(0);
    const { locale = 'eu' } = useRouter();

    const imgData: {
        [key: string]: any;
    } = {
        eu: {
            pc: [
                'https://websiteoss.ecoflow.com/upload/image/1747281176024/Frame%201612690174.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281147221/Frame%201612690173.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1754381634070/03.jpg',
            ],
            pad: [
                'https://websiteoss.ecoflow.com/upload/image/1747281218632/Frame%201612690201.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281218801/Frame%201612707408.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1754381658492/03.jpg',
            ],
            h5: [
                'https://websiteoss.ecoflow.com/upload/image/1747281277694/Frame%201612690199.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281278028/Frame%201612707409.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1754381677702/03.jpg',
            ],
            link: 'https://websiteoss.ecoflow.com/upload/pdf/1747225915706/OASIS%E9%A1%B5%E9%9D%A2BKW%E5%8A%9F%E8%83%BD%E5%88%97%E8%A1%A8_EN.pdf',
        },
        uk: {
            pc: [
                'https://websiteoss.ecoflow.com/upload/image/1747281334929/Frame%201612707386.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281335072/Frame%201612707385.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1754381715696/03.jpg',
            ],
            pad: [
                'https://websiteoss.ecoflow.com/upload/image/1747281390579/Frame%201612707389.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281390792/Frame%201612707388.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1754381738024/03.jpg',
            ],
            h5: [
                'https://websiteoss.ecoflow.com/upload/image/1747281436300/UK.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281436476/Frame%201612707391.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1754381758354/03.jpg',
            ],
            link: 'https://websiteoss.ecoflow.com/upload/pdf/1747225915706/OASIS%E9%A1%B5%E9%9D%A2BKW%E5%8A%9F%E8%83%BD%E5%88%97%E8%A1%A8_EN.pdf',
        },
        fr: {
            pc: [
                'https://websiteoss.ecoflow.com/upload/image/1747281492464/Frame%201612707416.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281492662/Frame%201612707415.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1754381796655/03.jpg',
            ],
            pad: [
                'https://websiteoss.ecoflow.com/upload/image/1747281531419/Frame%201612707419.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281531138/Frame%201612707418.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1754381817446/03.jpg',
            ],
            h5: [
                'https://websiteoss.ecoflow.com/upload/image/1747281570030/Frame%201612707422.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281570179/Frame%201612707421.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1754381843286/03.jpg',
            ],
            link: 'https://websiteoss.ecoflow.com/upload/pdf/1747225959313/OASIS%E9%A1%B5%E9%9D%A2BKW%E5%8A%9F%E8%83%BD%E5%88%97%E8%A1%A8_FR.pdf',
        },
        de: {
            pc: [
                'https://websiteoss.ecoflow.com/upload/image/1747281620043/Frame%201612707398.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281620232/Frame%201612707397.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1754381884945/03.jpg',
            ],
            pad: [
                'https://websiteoss.ecoflow.com/upload/image/1747281680267/Frame%201612707401.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281680071/Frame%201612707400.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1754381904717/03.jpg',
            ],
            h5: [
                'https://websiteoss.ecoflow.com/upload/image/1747281714432/Frame%201612707404.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281714579/Frame%201612707410.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1754381926034/03.jpg',
            ],
            link: 'https://websiteoss.ecoflow.com/upload/pdf/1747225915580/OASIS%E9%A1%B5%E9%9D%A2BKW%E5%8A%9F%E8%83%BD%E5%88%97%E8%A1%A8_DE.pdf',
        },
        es: {
            pc: [
                'https://websiteoss.ecoflow.com/upload/image/1747281790846/Frame%201612707444.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281790624/Frame%201612707443.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1754382286138/03.jpg',
            ],
            pad: [
                'https://websiteoss.ecoflow.com/upload/image/1747281827533/Frame%201612707447.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281827300/Frame%201612707446.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1754382295615/03.jpg',
            ],
            h5: [
                'https://websiteoss.ecoflow.com/upload/image/1747281860588/Frame%201612707450.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281860750/Frame%201612707449.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1754382310267/03.jpg',
            ],
            link: 'https://websiteoss.ecoflow.com/upload/pdf/1747225959123/OASIS%E9%A1%B5%E9%9D%A2BKW%E5%8A%9F%E8%83%BD%E5%88%97%E8%A1%A8_ES.pdf',
        },
        it: {
            pc: [
                'https://websiteoss.ecoflow.com/upload/image/1747281891941/Frame%201612707428.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281891755/Frame%201612707427.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1754382365910/03.jpg',
            ],
            pad: [
                'https://websiteoss.ecoflow.com/upload/image/1747281928343/Frame%201612707431.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281928142/Frame%201612707441.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1754382373463/03.jpg',
            ],
            h5: [
                'https://websiteoss.ecoflow.com/upload/image/1747282023310/Frame%201612707434.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747282023816/Frame%201612707440.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1754382379840/03.jpg',
            ],
            link: 'https://websiteoss.ecoflow.com/upload/pdf/1747225915913/OASIS%E9%A1%B5%E9%9D%A2BKW%E5%8A%9F%E8%83%BD%E5%88%97%E8%A1%A8_IT.pdf',
        },
    };

    return (
        <div className={`${styles.SubscriptionPlan} eco-content`}>
            <EfSpec />
            <div className="title">{t('title')}</div>
            {/* <EcoSpaceSmall /> */}
            <div className="box">
                <div className="img1">
                    <EfImg className="listA-card-img" pc={imgData[locale].pc[0]} pad={imgData[locale].pad[0]} h5={imgData[locale].h5[0]} />
                </div>
                <div className="img2">
                    <EfImg className="listA-card-img" pc={imgData[locale].pc[1]} pad={imgData[locale].pad[1]} h5={imgData[locale].h5[1]} />
                </div>
                <div className="img3">
                    <EfImg className="listA-card-img" pc={imgData[locale].pc[2]} pad={imgData[locale].pad[2]} h5={imgData[locale].h5[2]} />
                </div>
                <div className="box-desc">
                    {t('desc1')}
                    <br></br>
                    <br></br>
                    {t('desc2')}
                </div>
                {/* <div className="box-link"></div> */}
                <a className="box-link" href={imgData[locale].link} target="_blank" rel="noreferrer">
                    {t('link')}
                </a>
            </div>
        </div>
    );
}
